import React__default from 'react';
import { connectRefinementList } from 'react-instantsearch-core';
import { ButtonWithDropdown } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import FacetContainer from '../FacetContainer/FacetContainer.js';
import FacetInputList from './FacetInputList.js';

var ConnectedFacetInputList = connectRefinementList(ConnectedFacetInputList$1);
function ConnectedFacetInputList$1({ facet , attribute , items , refine , isActive , onToggle , searchable , searchForItems , isFromSearch  }) {
    const { getLabel  } = useIntl();
    if (!items.length && !isFromSearch) {
        return null;
    }
    const refineCount = items.filter((x)=>x.isRefined
    ).length;
    const ariaLabel = `${getLabel('search.filterBy')} ${getLabel(facet.labelKey || facet.id).toLowerCase()}`;
    var _label;
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "connected-facet-input-list"
    }, /*#__PURE__*/ React__default.createElement(ButtonWithDropdown, {
        "aria-label": ariaLabel,
        onClick: ()=>onToggle(attribute)
        ,
        isActive: isActive,
        label: (_label = facet.label) !== null && _label !== void 0 ? _label : getLabel(facet.labelKey || facet.id),
        className: "connected-facet-input-list__button",
        id: isActive ? 'activeFacet' : undefined
    }, /*#__PURE__*/ React__default.createElement(FacetContainer, {
        onSearch: searchable ? searchForItems : undefined,
        onClear: ()=>refine([])
        ,
        enableClearButton: refineCount > 0,
        title: /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, refineCount, ' ', getLabel('search.filters.selected', {
            defaultValue: 'selected'
        }))
    }, /*#__PURE__*/ React__default.createElement(FacetInputList, {
        facet: facet,
        items: items,
        onRefine: refine
    }))));
}

export { ConnectedFacetInputList$1 as ConnectedFacetInputList, ConnectedFacetInputList as default };
//# sourceMappingURL=ConnectedFacetInputList.js.map
